// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-account-section{padding:0;margin:0}.my-account-section .my-account-content{padding:2%;border:0.1rem solid #fff}.my-account-section form label{text-transform:uppercase;font-weight:normal;text-align:left !important}.my-account-section form .form-title button{margin:0 1rem;text-transform:uppercase;border:none;background:none}.my-account-section form .form-title button:focus{outline:none}\n", ""]);
// Exports
module.exports = exports;
